import React from 'react';
import { 
  Shield, 
  ArrowLeft,
  Lock,
  AlertCircle
} from 'lucide-react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import AnnouncementBar from '../../components/AnnouncementBar';
import Footer from '../../components/Footer';

const PrivacyPolicy: React.FC = () => {
  const { language, setLanguage, isRTL } = useLocalization();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const content = {
    ar: {
      title: "سياسة الخصوصية",
      lastUpdated: "آخر تحديث: 23 أكتوبر 2026 (الإصدار 2.4.0)",
      sections: [
        {
          title: "1. مقدمة",
          content: "تشرح سياسة الخصوصية هذه كيف تجمع شركة أوبتيميز وير معلوماتك الشخصية وتستخدمها وتحميها عند استخدام منصة مرافعة (الموقع والتطبيقات). نحن ملتزمون بحماية خصوصيتك والامتثال لقانون حماية البيانات الشخصية المصري رقم 151 لسنة 2020."
        },
        {
          title: "2. المعلومات التي نجمعها",
          content: "معلومات شخصية: الاسم والبريد والهاتف والمؤهلات وبيانات النقابة عند تقديمها وعنوان المكتب والصور المهنية. بيانات العملاء التي ترفعها: أسماء الموكلين والمستندات والمواعيد والملاحظات والمعلومات المالية المرتبطة بالقضايا. معلومات تقنية: IP والجهاز وأنماط الاستخدام وعدد الجلسات وتواريخ أول/آخر جلسة وإسناد الحملات (UTM / Install Referrer) وأكواد الإحالة وسجلات المنح والاستحقاق واستبيانات صوت الإصدار الاختيارية وملفات تعريف الارتباط وSDK وسجلات الأخطاء. عند شراء Ad-Free: معرّف المنتج والطلب والمبلغ (50 جنيهاً شاملة الضريبة) ومرجع Kashier وتواريخ الصلاحية. لا نخزّن رقم البطاقة الكامل أو CVV."
        },
        {
          title: "3. كيف نستخدم معلوماتك",
          content: "تقديم الخدمة والمصادقة وإدارة الممارسة وتشغيل برنامج الإحالة ومنح Ad-Free الترويجي عند استيفاء الشروط، ومعالجة شراء Ad-Free المدفوع عبر Kashier ومنح أو إنهاء الصلاحية، والتواصل والدعم، والامتثال القانوني ومنع الاحتيال، وتحسين المنتج وقياس الحملات، وعرض وقياس الإعلانات كما في بند الإعلانات."
        },
        {
          title: "4. الأساس القانوني للمعالجة",
          content: "الموافقة، أداء العقد، الالتزام القانوني، والمصلحة المشروعة لتحسين الخدمة ومنع الإساءة وضمان الأمان."
        },
        {
          title: "5. مشاركة البيانات والمعالجون",
          content: "لا نبيع بياناتك الشخصية. قد نشاركها مع مقدمي خدمات يشغّلون المنصة، أو عند المتطلبات القانونية، أو في تحويلات تجارية، أو بموافقتك. المعالجون الحاليون حسب الميزات: Google Firebase (المصادقة وFirestore والاستضافة)، Google Sign-In، Google AdMob وGoogle AdSense عند التفعيل، Vercel أو استضافة مماثلة لواجهات الـ API، وKashier لمعالجة البطاقة/المحفظة عند شراء Ad-Free (نرسل البريد أو بديلاً ومعرّف المستخدم والطلب والمبلغ؛ لا نخزّن PAN/CVV). قد تُعالَج بيانات خارج مصر. لا نشارك محتوى القضايا أو بيانات العملاء أو المستندات مع شبكات الإعلانات لتخصيص الإعلانات. لا نستخدم Google Play Billing."
        },
        {
          title: "6. تدابير أمن البيانات",
          content: "تشفير أثناء النقل (TLS/SSL)، وتشفير أثناء التخزين حيث يتيحه مزودو السحابة، وضوابط وصول ومراقبة. لا ندّعي تشفيراً من طرف إلى طرف لكل محتوى المنصة بين المستخدمين؛ الأمان يعتمد أيضاً على حماية حسابك وجهازك وضوابط المعالجين."
        },
        {
          title: "7. الاحتفاظ بالبيانات",
          content: "بيانات الحساب حتى الإغلاق مع فترة امتثال عند الاقتضاء؛ بيانات العملاء وفق التزاماتك المهنية؛ بيانات تقنية/تحليلية حتى نحو سنتين؛ بيانات تسويق حتى الانسحاب أو 3 سنوات عدم نشاط؛ سجلات الإحالة والاستحقاق طالما لزم تشغيل البرنامج والتدقيق."
        },
        {
          title: "8. حقوقك بموجب القانون المصري",
          content: "حق الوصول والتصحيح والمحو وقابلية النقل وتقييد المعالجة والاعتراض وسحب الموافقة — عبر privacy@morafaaapp.com أو الهاتف +201202322241."
        },
        {
          title: "9. نقل البيانات الدولية",
          content: "عند المعالجة خارج مصر عبر المعالجين أعلاه نعتمد ضمانات تعاقدية وتقنية مناسبة وموافقتك عند اللزوم."
        },
        {
          title: "10. ملفات تعريف الارتباط والإعلانات",
          content: "نستخدم ملفات تعريف الارتباط وSDK للتفضيلات والتحليلات والأمان والإعلانات. على الويب قد تُخزَّن معاملات UTM محلياً حتى تسجيل الدخول. قد تعرض مرافعة إعلانات عبر AdMob (التطبيقات) وAdSense (الموقع عند التفعيل). في المناطق التي تتطلب موافقة إضافية قد نعرض نموذج موافقة Google. لا نشارك محتوى القضايا أو بيانات العملاء مع شبكات الإعلانات لتخصيص الإعلانات."
        },
        {
          title: "11. برنامج الإحالة واستبيان الصوت",
          content: "عند استخدام كود إحالة نخزّن الكود وربط المحيل والمُحال وحالة المنح لمنح وتدقيق أشهر Ad-Free الترويجية (التفاصيل في الشروط والأحكام). قد نعرض استبياناً اختيارياً مرتبطاً بحسابك وإصدار التطبيق؛ يمكنك الإغلاق دون إكمال."
        },
        {
          title: "12. خصوصية الأطفال",
          content: "المنصة غير مخصصة لمن دون 18 عاماً. لا نجمع بياناتهم عن علم؛ وإن علمنا نحذفها فوراً."
        },
        {
          title: "13. إشعار خرق البيانات",
          content: "نبلّغك والجهات المختصة كما يقتضي القانون، ونحتوى الحادث ونقدّم إرشادات عملية عند الإمكان."
        },
        {
          title: "14. التغييرات ومعلومات التواصل",
          content: "قد نحدّث السياسة دورياً؛ التغييرات الجوهرية تُنشر على المنصة وقد تُبلَّغ بالبريد أو داخل التطبيق. للتواصل: privacy@morafaaapp.com — +201202322241 — القاهرة، مصر. الشكاوى: تواصل معنا أولاً ثم الجهات المختصة بموجب القانون المصري."
        }
      ]
    },
    en: {
      title: "Privacy Policy",
      lastUpdated: "Last Updated: 23 October 2026 (Release 2.4.0)",
      sections: [
        {
          title: "1. Introduction",
          content: "This Privacy Policy explains how OptimizeWare collects, uses, discloses, and protects your personal information when you use Morafaa (website and apps). We aim to comply with Egyptian Personal Data Protection Law No. 151 of 2020 and international privacy standards."
        },
        {
          title: "2. Information We Collect",
          content: "Personal information: name, email, phone, professional credentials, bar details when provided, office contact, profile photos. Client data you upload: names, documents, dates, notes, related financials. Technical data: IP, device, usage, session counts and first/last session timestamps, campaign attribution (UTM / Install Referrer), referral codes and grant/entitlement records, optional release surveys, cookies/SDKs, and logs. When you buy Ad-Free: product id, order id, amount (50 EGP VAT-inclusive), Kashier transaction reference, and entitlement dates. We do not store full card PAN or CVV."
        },
        {
          title: "3. How We Use Your Information",
          content: "Provide the Service and authentication; run referrals and apply promotional Ad-Free entitlements when rules are met; process paid Ad-Free checkout via Kashier and grant or end access; support and communications; legal compliance and fraud/abuse prevention; product improvement and campaign measurement; serve and measure advertising as described below."
        },
        {
          title: "4. Legal Basis for Processing",
          content: "Consent, contract performance, legal obligation, and legitimate interests (service improvement, abuse prevention, security)."
        },
        {
          title: "5. Sharing and Processors",
          content: "We do not sell personal data. We may share with processors that operate the platform, when required by law, in a business transfer, or with your consent. Current processors (as features are used): Google Firebase (Auth, Firestore, Hosting), Google Sign-In, Google AdMob and Google AdSense where enabled, Vercel or similar API hosting, and Kashier for card/wallet processing on Ad-Free (we send email or a placeholder, user/order ids, and amount; we do not store PAN/CVV). Data may be processed outside Egypt. We do not share case content, client data, or legal documents with ad networks for ad personalization. Google Play Billing is not used."
        },
        {
          title: "6. Data Security Measures",
          content: "TLS/SSL in transit; encryption at rest where provided by cloud processors; access controls and monitoring. We do not claim end-to-end encryption of all platform content between users. Security also depends on your account and device hygiene and processor controls."
        },
        {
          title: "7. Data Retention",
          content: "Account data until closure plus applicable compliance periods; client data per your professional needs and platform settings; technical/analytics up to about 2 years; marketing until opt-out or 3 years inactivity; referral and entitlement records as needed to run and audit the program."
        },
        {
          title: "8. Your Rights Under Egyptian Law",
          content: "Access, rectification, erasure, portability, restriction, objection, and withdraw consent — contact privacy@morafaaapp.com or +201202322241."
        },
        {
          title: "9. International Transfers",
          content: "When processors handle data outside Egypt we rely on appropriate contractual/technical safeguards and consent where required."
        },
        {
          title: "10. Cookies and Advertising",
          content: "Cookies/SDKs for preferences, analytics, security, and ads. Web may store UTM locally until login. Ads may use Google AdMob (apps) and Google AdSense (website where enabled). Where required we may show a Google consent form. We do not share case/client documents with ad networks for personalization."
        },
        {
          title: "11. Referral Program and Surveys",
          content: "Referral use stores codes, referrer–invitee links, and grant status to award and audit promotional Ad-Free months (see Terms). Optional release surveys may be linked to your account and app version; you may dismiss without completing."
        },
        {
          title: "12. Children's Privacy",
          content: "Not intended for users under 18. We do not knowingly collect children's data; if we learn we have, we delete it."
        },
        {
          title: "13. Data Breach Notification",
          content: "We will notify you and authorities as required, contain the incident, and provide practical guidance where appropriate."
        },
        {
          title: "14. Changes and Contact",
          content: "We may update this Policy; material changes are posted on the platform and may be notified by email or in-app. Contact: privacy@morafaaapp.com — +201202322241 — Cairo, Egypt. Raise concerns with us first, then competent authorities under Egyptian law."
        }
      ]
    }
  };

  const currentContent = content[language as keyof typeof content];

  return (
    <div className={`min-h-screen bg-background-light dark:bg-background-dark ${isRTL ? 'rtl' : 'ltr'}`}>
      <AnnouncementBar />
      
      {/* Header */}
      <div className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4 rtl:space-x-reverse">
              <button
                onClick={() => navigate(-1)}
                className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div className="flex items-center space-x-3 rtl:space-x-reverse">
                <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                  <Shield className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                    {currentContent.title}
                  </h1>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {currentContent.lastUpdated}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Theme & Language Toggle */}
            <div className="flex items-center space-x-3">
              <button
                onClick={toggleTheme}
                className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                title={language === 'ar' ? 'تبديل المظهر' : 'Toggle Theme'}
              >
                {isDark ? '☀️' : '🌙'}
              </button>
              
              <button
                onClick={() => setLanguage(language === 'ar' ? 'en' : 'ar')}
                className="px-3 py-1 text-sm rounded-md transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
              >
                {language === 'ar' ? 'English' : 'العربية'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-8">
          {/* Introduction */}
          <div className="mb-8 p-6 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800">
            <div className="flex items-start space-x-3 rtl:space-x-reverse">
              <Lock className="w-6 h-6 text-blue-600 dark:text-blue-400 mt-1 flex-shrink-0" />
              <div>
                <h2 className="text-lg font-semibold text-blue-900 dark:text-blue-100 mb-2">
                  {language === 'ar' ? 'مقدمة' : 'Introduction'}
                </h2>
                <p className="text-blue-800 dark:text-blue-200 leading-relaxed">
                  {language === 'ar' 
                    ? 'نحن ملتزمون بحماية خصوصيتك وضمان الامتثال لأعلى معايير حماية البيانات. هذه السياسة توضح كيف نجمع ونستخدم ونحمي معلوماتك الشخصية.'
                    : 'We are committed to protecting your privacy and ensuring compliance with the highest data protection standards. This policy explains how we collect, use, and protect your personal information.'
                  }
                </p>
              </div>
            </div>
          </div>

          {/* Privacy Sections */}
          <div className="space-y-8">
            {currentContent.sections.map((section, index) => (
              <div key={index} className="border-b border-gray-200 dark:border-gray-700 pb-6 last:border-b-0">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4 flex items-center">
                  <span className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold mr-3 rtl:mr-0 rtl:ml-3">
                    {index + 1}
                  </span>
                  {section.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4 ml-11 rtl:ml-0 rtl:mr-11 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          {/* Important Notice */}
          <div className="mt-12 p-6 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-200 dark:border-amber-800">
            <div className="flex items-start space-x-3 rtl:space-x-reverse">
              <AlertCircle className="w-6 h-6 text-amber-600 dark:text-amber-400 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-lg font-semibold text-amber-900 dark:text-amber-100 mb-2">
                  {language === 'ar' ? 'إشعار مهم' : 'Important Notice'}
                </h3>
                <p className="text-amber-800 dark:text-amber-200 leading-relaxed">
                  {language === 'ar' 
                    ? 'يُنصح بقراءة سياسة الخصوصية هذه بعناية. في حالة وجود أي أسئلة حول كيفية استخدامنا لبياناتك، يرجى التواصل معنا. استمرار استخدامك للمنصة يعني موافقتك على هذه السياسة.'
                    : 'Please read this Privacy Policy carefully. If you have any questions about how we use your data, please contact us. Your continued use of the platform means your acceptance of this policy.'
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
